<!--header-right-->
<template>
  <div class="home-business-card-city" :class="{w100: !placeholder2}" :fontType="fontType">
    <div class="departure" :class="{wrap: busType === 'date' && _isCanBookPreDay(title1)}" @click="$emit('clickLeft')">
      <div v-if="index !== null" class="index">{{index + 1}}</div>
      <div class="text" v-if="title1">
        <div class="text-content">
          <span>{{busType === 'date' ? $t(_isCanBookPreDay(title1) ? beTime(getNewDate(NewDate(title1), 0, 0, 1)) : title1, "date", ["MM月dd日", "MM dd",]) : title1}}</span>
          <span v-if="title1 && busType === 'date'" class="subTitle">
            {{_isCanBookPreDay(title1) ? $t("Morning") : (segmentType === 2 ? $t('DepartureWeek_x', 'function', [getWeeks(title1)]) : getWeeks(title1))}}
          </span>
          <div v-else-if="subTitle1" class="subTitle">{{subTitle1}}</div>
        </div>
      </div>
      <span v-else class="gray">{{placeholder1}}</span>
      <span v-if="clearable && title1" class="clear" @click.stop="$emit('clear')" :style="{backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close.svg')})`}"></span>
      <slot name="right-icon">
        <span v-if="showRightIcon" class="clear" @click.stop="$emit('clickRightIcon')" :style="{backgroundImage: `url(${require('@/assets/image/home/icons_24pt_position_O300.svg')})`}"></span>
      </slot>
    </div>
    <!-- 表示右侧也有内容 -->
    <template v-if="placeholder2">
      <div v-if="busType === 'date'" class="night">
        <span v-if="getApartDayCountFun(title1, title2) > 0">
          {{title1 && title2 && getApartDayCountFun(title1, title2) > 0 ? _getMiddleDate() : ""}}
        </span>
      </div>
      <div
          v-else
          class="switch"
          @click="_switch"
          :style="{transform: `rotate(${360 * rotate}deg)`,backgroundImage: `url(${require('@/assets/image/home/icons_32pt_flight.svg')})`}"
      ></div>
      <div class="arrive" :class="{wrap: busType === 'date' && _isToday(title2) && _isBeforeDawn()}" @click="$emit('clickRight')">
        <div class="text" v-if="title2">
          <div class="text-content">
            <span>{{busType === 'date' ? $t(title2, "date", ["MM月dd日", "MM dd",]) : title2}}</span>
            <span v-if="title2 && busType === 'date'" class="subTitle">
              {{_isToday(title2) && _isBeforeDawn() ? $t("Noon") : (segmentType === 2 ? $t('DepartureWeek_x', 'function', [getWeeks(title2)]) : getWeeks(title2))}}
            </span>
          </div>
        </div>
        <span v-else class="gray">{{placeholder2}}</span>
      </div>
    </template>
  </div>
</template>
<script type="text/ecmascript-6">
import HsButton from "@/base/hs-button/hs-button.vue";
import HsTab2 from "@/base/hs-tab/hs-tab-2.vue";
import HsTab4 from "@/base/hs-tab/hs-tab-4.vue";
export default {
  props: {
    busType: {
      type: String,
      default: ""
    },
    title1: {
      type: String,
      default: ""
    },
    placeholder1: {
      type: String,
      default: ""
    },
    subTitle1: {
      type: String,
      default: ""
    },
    title2: {
      type: String,
      default: ""
    },
    placeholder2: {
      type: String,
      default: ""
    },
    subTitle2: {
      type: String,
      default: ""
    },
    orderBusinessType: { // 1 机票 2 酒店
      type: Number,
      default: 1
    },
    fontType: { // middle
      type: String,
      default: ""
    },
    clearable: { // 是否启用清除图标，点击清除图标后会清空
      type: Boolean,
      default: false,
    },
    showRightIcon: { // 右侧图标
      type: Boolean,
      default: false,
    },
    index: { // 左侧 序号
      type: Number,
      default: null,
    },
    YesterdayCloseHours: { // 酒店凌晨入住参数
      type: Number,
      default: 0,
    },
    segmentType: { // 行程类型 0 单程 1 往返 2多程
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedIndex: 0,
      rotate: 0,
    }
  },
  methods: {
    _getMiddleDate() {
      if (this.orderBusinessType === 2) {
        return this.$t("TotalNights", "function", [this.getApartDayCountFun(this.title1, this.title2) - 1])
      }
      return this.$t("TotalOfDay_x", "function", [this.getApartDayCountFun(this.title1, this.title2)])
    },

    _switch() {
      this.$emit('switch')
      this.rotate += 1
    },

    getApartDayCountFun(date1, date2) {
      let days = this.getApartDayCount(date1, date2)
      return days > 0 ? days + 1 : 0
    },

    /** 是否可以下昨天的单 */
    _isCanBookPreDay(date) {
      if (!date) { return false }
      let yesterday = this.getNewDate(new Date(), 0, 0, -1)
      if (this.beTime(date) === this.beTime(yesterday) && this._isBeforeDawn()) {
        return true
      }
      return false
    },

    /** 是否有凌晨下单时间点 且当前时间小于凌晨时间点 */
    _isBeforeDawn() {
      let hours = new Date().getHours()
      return this.YesterdayCloseHours > 0 && hours < this.YesterdayCloseHours
    },

    // 是否为今天
    _isToday(date) {
      return date === this.beTime(new Date())
    },
  },
  components: {
    HsTab2,
    HsTab4,
    HsButton
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
$height = 56px
/** 超标支付样式  */
.home-business-card-city
  @extend .flex-between
  width 100%
  height $height
  box-shadow 0px -0.5px 0px 0px $color_black_30 inset
  &:last-child
    box-shadow none
  &.w100
    >.departure
      width 100%
  &[fontType='middle']
    >.departure, >.arrive
      @extend .hs-font-subtitle-big
      >.text
        >span:first-child
          font-weight 500
  >.departure, >.arrive
    @extend .flex-start
    @extend .hs-font-title-small
    width calc(50% - 12px)
    height $height
    color $color_black_900
    >.index
      @extend .flex-center
      @extend .hs-font-overline-1
      flex-shrink 0
      width 16px
      height 16px
      border-radius 4px
      color $color_black_0
      background $color_theme_300
      margin-right 4px
    >.text
      @extend .flex-start
      flex-direction column
      align-items flex-start
      width 100%
      >.subtitle1
        @extend .hs-font-caption-1
        color $color_black_100
      >.text-content
        @extend .flex-start
        align-items baseline
        flex-wrap wrap
        >span:first-child
          font-weight 600
        >span
          ellipsis(1)
        >.subTitle
          @extend .hs-font-body
          color $color_black_100
          margin-left 4px
    >.gray
      @extend .hs-font-body-note-1
      width 100%
      color $color_black_50
    >.clear
      flex-shrink 0
      width 24px
      height 24px
      background-size 100% 100%
      background-position no-repeat
      margin-left 12px
  >.arrive
    @extend .flex-end
    >.text
      @extend .flex-end
      align-items flex-end
    >.gray
      text-align right
  >.night
    @extend .flex-center
    @extend .hs-font-overline-1
    width 32px
    height 16px
    border-radius 3px
    color $color_black_400
    >span
      font-weight 500
      text-align center
      background $color_black_20
      border-radius 3px
      width 100%
      height 100%
  >.switch
    flex-shrink 0
    width 32px
    height 32px
    background-size 100% 100%
    background-repeat no-repeat
    background-position center
    margin 0 12px
    transition all .4s
</style>
